import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)
Vue.config.productionTip = false

const vues = document.querySelectorAll(".sku_rate_schedule");
const each = Array.prototype.forEach;


each.call(vues, function (el, index)
{
    var data = {
        sku_id:  el.getAttribute('sku_id'),
    }

    new Vue({
        data:   data,
        render: h => h(App),
    }).$mount(el)
})
